<template>
  <v-row no-gutters>
    <v-col cols="12" class="pt-2 pb-2">
      <v-list-item class="pa-0" v-for="(item, index) in surveyTargets" :key="index" style="max-height: 28px; min-height: auto">
        <v-list-item-avatar size="20" class="my-0 mr-2">
            <v-img
                v-if="item.profilePhoto"
                contain
                :src="item.profilePhoto"
              >
            </v-img>
            <v-img v-else src="@/assets/images/No-Photo.jpg"></v-img>
          </v-list-item-avatar>
          <v-list-item-content class="my-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title
                  v-bind="attrs"
                  v-on="on"
                  class="text-truncate body-m"
                  style="max-width: 200px"
                  >{{
                    item.firstName
                      ? item.firstName + " " + item.lastName
                      : item.email
                  }}
                </v-list-item-title>
              </template>
              <span>{{
                item.firstName
                  ? item.firstName + " " + item.lastName
                  : item.email
              }}</span>
            </v-tooltip>
          </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "SurveyTargetList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localUserList: [],
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    surveyTargets() {
      return this.items.map((item) => {
        const uData = this.updatedUserList.find((u) => u.id == item.id);
        return {
          id: item.id,
          email: item.email,
          attendedState: item.attendedState,
          firstName: uData ? uData.firstName : "",
          lastName: uData ? uData.lastName : "",
          profilePhoto: uData ? uData.profilePhoto : "",
        };
      });
    },
    updatedUserList: {
      get() {
        return this.localUserList;
      },
      set(value) {
        this.localUserList = value;
      },
    },
  },
  async mounted() {
    if (this.userList.length) {
      this.localUserList = _.cloneDeep(this.userList);
      await this.addDeletedUserDetails();
    }
  },
  methods: {
    ...mapActions({
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
    }),
    addDeletedUserDetails,
  },
};

async function addDeletedUserDetails() {
  const objectWithIdExists = (id) => this.userList.some((obj) => obj.id === id);

  const unmatchedObjects = this.items.filter(
    (obj) => !objectWithIdExists(obj.id)
  );
  const unmatchedIds = unmatchedObjects.map((obj) => obj.id);
  if (unmatchedIds.length) {
    const result = await this.getDeletedUsersList(unmatchedIds);
    if (result.length) {
      this.localUserList = this.localUserList.concat(result);
    }
  }
}
</script>

<style>
</style>